
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/strategy-lab",
      function () {
        return require("private-next-pages/embed/strategy-lab.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/strategy-lab"])
      });
    }
  